export default __webpack_public_path__ + "static/media/number_views.71779932.svg";